import Cookies from "js-cookie";

export function getDomain() {
  let domain = ".captyn.com";

  if (process.env.NEXT_PUBLIC_STAGE === "demo") {
    domain = ".nytpac.com";
  }

  if (process.env.NEXT_PUBLIC_STAGE === "test") {
    domain = window.location.hostname;
  }

  if (process.env.NODE_ENV === "development") {
    const hostname = window.location.hostname;
    domain =
      hostname === "local.localhost" || hostname.endsWith(".local.localhost")
        ? ".local.localhost"
        : "localhost";
  }

  return domain;
}

export function getToken() {
  const domain = getDomain();

  const cookieConfig = {
    domain,
  };

  let token = Cookies.get("accessToken", cookieConfig);

  if (!token) {
    try {
      const kioskToken = window.sessionStorage.getItem("kiosk");

      if (kioskToken && kioskToken !== "true") {
        token = kioskToken;
      }
    } catch {
      token = undefined;
    }
  }

  if (
    Cookies.get("viewingAs", cookieConfig) &&
    Cookies.get("viewingAsToken", cookieConfig)
  ) {
    token = Cookies.get("viewingAsToken", cookieConfig);
  }

  return token;
}

function removeAuthCookie(name: string) {
  // Legacy cookies can coexist at the shared domain and the current host.
  for (const domain of new Set([getDomain(), window.location.hostname])) {
    Cookies.remove(name, { domain, path: "/" });
  }
  Cookies.remove(name, { path: "/" });
}

export function removeToken() {
  for (const name of [
    "accessToken",
    "viewingAs",
    "viewingAsToken",
    "returnPathname",
  ]) {
    removeAuthCookie(name);
  }
}

export function setToken(token) {
  const expires = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);
  const domain = getDomain();

  const cookieConfig = {
    expires,
    domain,
  };

  Cookies.set("accessToken", token, cookieConfig);
}

export function setViewAsToken(args: {
  viewingAs: string;
  viewingAsToken: string;
  returnPathname: string;
}) {
  const expires = new Date(new Date().getTime() + 60 * 60 * 1000);
  const domain = getDomain();

  const cookieConfig = {
    expires,
    domain,
  };

  Cookies.set("viewingAs", args.viewingAs, cookieConfig);
  Cookies.set("viewingAsToken", args.viewingAsToken, cookieConfig);
  Cookies.set("returnPathname", location.pathname, cookieConfig);
}

export function removeViewAsToken() {
  const returnPathname = Cookies.get("returnPathname") || "/";

  removeAuthCookie("viewingAs");
  removeAuthCookie("viewingAsToken");
  removeAuthCookie("returnPathname");

  return returnPathname;
}
